import React, { Component } from 'react'
import Button from '@ui/Button'
import OtherInput from '@ui/OtherInput'
import DragAndDrop from '@ui/DragAndDrop'
import cn from 'classnames'

export default class MultipleChoice extends Component {
  render() {
    const {
      id,
      choices = [],
      showForm,
      withForm,
      formPlaceholder,
      formValue,
      onRemove,
      onChange,
      onDrop,
      onDrag,
      onClick,
      inactive,
      mode,
      onChangeForm
    } = this.props

    const buttons = choices.map((choice, choiceIndex) => {
      const button = (
        <Button
          key={`choice-${id}-${choice.value}`}
          id={choice.value}
          onChange={onChange}
          primary={choice.selected}
          size='big'
          editable={choice.editable}
          onRemove={choice.removable ? onRemove : null}
          onClick={onClick}
          content={choice.text}
          inactive={inactive || choice.inactive}
          fluid
        />
      )

      return choice.editable ? (
        <DragAndDrop
          key={`choice-${id}-${choice.value}`}
          index={choiceIndex}
          itemType='option'
          onMove={onDrag}
          onDrop={onDrop}
        >
          {button}
        </DragAndDrop>
      ) : (
        button
      )
    })

    return (
      <div>
        <div className={cn('buttons-in-column', mode)}>{buttons}</div>
        {withForm && (
          <OtherInput
            value={formValue}
            placeholder={formPlaceholder}
            onChange={onChangeForm}
            hidden={!showForm}
          />
        )}
      </div>
    )
  }
}
